import BooleanFilterDefinition from "vcomponents/listing/apiListing/filtersDefinition/BooleanFilterDefinition";
import AccountingListingMapping from 'vcomponents/listing/apiListing/mapping/AccountingListingMapping.js';
import SelectFilterDefinition from "vcomponents/listing/apiListing/filtersDefinition/SelectFilterDefinition";
import ColumnDefinition from "../ColumnDefinition";

let BankAccountingListingMapping = _.cloneDeep(AccountingListingMapping);

BankAccountingListingMapping['filters'].push(
    new BooleanFilterDefinition("simplified_view_by_client", i18n.__("Vue simplifiée par client"))
);

BankAccountingListingMapping['filters'].push(
    (new SelectFilterDefinition('bank_accounts', i18n.__("Comptes bancaires"), function () {
        return this.metas.bankAccounts;
    }, true))
);

BankAccountingListingMapping['columns'].push(
    new ColumnDefinition(
        'documents.linked',
        i18n.__("Documents liés"),
        false,
        false,
        function (formatted, row) {
            let docIds = [];
            row.documents.forEach((document) => {
                docIds.push(document.number);
            });

            return docIds.join(', ');
        },
        {
            prop: 'documents',
            display: true,
        }
    )
);

BankAccountingListingMapping['columns'].forEach(column => {
    //hide some columns by default for bank journal
    if (["company-individual.name", "document.subject", "auxiliary_code", 'document.number'].includes(column.name)) {
        column.configuration.display = false;
    }
});

export default BankAccountingListingMapping
